var map = {
	"./": 112,
	"./es": 89,
	"./es/": 89,
	"./es/admin": 115,
	"./es/admin.d": 150,
	"./es/admin.d.ts": 150,
	"./es/admin.js": 115,
	"./es/cattle_species": 114,
	"./es/cattle_species.d": 151,
	"./es/cattle_species.d.ts": 151,
	"./es/cattle_species.js": 114,
	"./es/import_export": 116,
	"./es/import_export.d": 152,
	"./es/import_export.d.ts": 152,
	"./es/import_export.js": 116,
	"./es/index": 89,
	"./es/index.d": 153,
	"./es/index.d.ts": 153,
	"./es/index.js": 89,
	"./es/notebook": 113,
	"./es/notebook.d": 154,
	"./es/notebook.d.ts": 154,
	"./es/notebook.js": 113,
	"./gl/cattle_species": 141,
	"./gl/cattle_species.d": 155,
	"./gl/cattle_species.d.ts": 155,
	"./gl/cattle_species.js": 141,
	"./index": 112,
	"./index.d": 156,
	"./index.d.ts": 156,
	"./index.js": 112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 224;